import { cn } from "@photo-booth/ui";
import { Button } from "@photo-booth/ui/button";

type Props = React.ComponentProps<typeof Button>;

export const CaptureButton: React.FC<Props> = ({ className, ...props }) => {
    const buttonClassName = cn("h-[75px] w-[75px] bg-vintage-red border-4 border-white rounded-[50%] hover:opacity-70 active:opacity-70", className);
  return (
    <div className="border-vintage-red border-4 rounded-[50%] w-[80px] h-[80px] flex items-center justify-center hover:opacity-70 active:opacity-70">
      <Button className={buttonClassName} {...props} />
    </div>
  );
};
